import { render, staticRenderFns } from "./VehicleModelList.vue?vue&type=template&id=45bde989"
import script from "./VehicleModelList.vue?vue&type=script&lang=js"
export * from "./VehicleModelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports